var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    viewBox: "0 0 12 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.5C6.43386 0.5 8 2.06614 8 4V14.5C8 15.6039 7.10386 16.5 6 16.5C4.89614 16.5 4 15.6039 4 14.5V5.5H4.5V14.5C4.5 15.3261 5.17386 16 6 16C6.82614 16 7.5 15.3261 7.5 14.5V4C7.5 2.34386 6.15614 1 4.5 1C2.84386 1 1.5 2.34386 1.5 4V16.5C1.5 18.9861 3.51386 21 6 21C8.48614 21 10.5 18.9861 10.5 16.5V5.5H11V16.5C11 19.2639 8.76386 21.5 6 21.5C3.23614 21.5 1 19.2639 1 16.5V4C1 2.06614 2.56614 0.5 4.5 0.5Z",
    fill: "#495054",
    stroke: "#495054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.cb8fff5c167a1cc6f1d0a71dc127cf0c.svg";
export { ForwardRef as ReactComponent };